export default __webpack_public_path__ + "static/media/human-greeting.78f28152.svg";